<!--
 * @Author: your name
 * @Date: 2021-06-22 08:48:30
 * @LastEditTime: 2021-07-14 14:57:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /pbr/src/components/pbr/index/Index.vue
-->
<template>
  <el-row :gutter="20">
    <my-project ref="publish" :readonly="true"></my-project>
    <el-col :md="18" :xs="24" class="pbr-index-map-outer" style="position:relative;">
      <el-row class="pbr-index-map">
        <tdt-map ref="mapview"></tdt-map>
      </el-row>
      <el-row class="pbr-index-charts">
        <div v-if="emphasesCategory === 'sj' || emphasesCategory === ''"
             :class="{'pbr-index-charts-container-single':emphasesCategory === 'sj'}"
             class="echarts-box">
          <business :data="businessChartData"
                    :single="emphasesCategory === 'sj'"
                    @getChartReply="getChartReply" @business-country-chart-click="businessCountryChartClick"></business>
        </div>
        <div v-if="emphasesCategory === 'fx' || emphasesCategory === ''"
             :class="{'pbr-index-charts-container-single':emphasesCategory === 'fx'}"
             class="echarts-box">
          <risk :data="riskChartData"
                :single="emphasesCategory === 'fx'"></risk>
        </div>
        <div v-if="emphasesCategory === 'xm' || emphasesCategory === ''"
             :class="{'pbr-index-charts-container-single':emphasesCategory === 'xm'}"
             class="echarts-box">
          <project :data="projectChartData"
                   :single="emphasesCategory === 'xm'"></project>
        </div>
      </el-row>
      <!-- <Spin size="large" >
             <Icon type="ios-loading" size=28 class="demo-spin-icon-load"></Icon>
            <div>数据更新中...</div>
        </Spin> -->
<!--      <Spin v-if="spinShow" class="pbrSpin"-->
<!--            fix-->
<!--            size="large">-->
<!--        <div v-if="isLoadMapDataError" style="display:flex; flex-direction: column;align-items:center;">-->
<!--          <span style="color: #fe625a; margin:10px;">{{$t('label.home.loadDataError')}}</span>-->
<!--          <Button v-if="isLoadMapDataError" icon="md-repeat" shape="circle" size="small" style="width:70px;"-->
<!--                  type="primary" @click="spinRefreshClick">{{$t('label.home.retry')}}-->
<!--          </Button>-->
<!--        </div>-->
<!--      </Spin>-->
    </el-col>
    <el-col :md="6" :xs="24"
            class="pbr-index-right-col"
            style="height: 100%">
      <div class="pbr-index-right-item">
        <Tabs type="card" v-model="topTabName"
              @on-click="topTabClick">
          <TabPane class="pbr-index-tab-pane" :label="$t('tabs.home.latestProject')"
                   name="newest">
            <project-list-curly v-if="topTabName === 'newest'" :pageSize="pbrIndexRightTablePageSize" listKey="records"
                                url='/front/project/list'></project-list-curly>
          </TabPane>
          <TabPane class="pbr-index-tab-pane" :label="$t('tabs.home.keyProject')"
                   name="emphases">
            <project-list-curly v-if="topTabName === 'emphases'" :pageSize="pbrIndexRightTablePageSize" :params="{pageNo:1, pageSize:20, from:'cn', hmodule:'wp'}"
                                listKey="models" method="POST"
                                url="/front/project/psearch"></project-list-curly>
          </TabPane>
          <TabPane class="pbr-index-table pbr-index-tab-pane" :label="$t('tabs.home.myProject')"
                   name="my">
            <normal-list v-if="myProjectData.length > 0" :columns="['title','status','time']"
                         :item-click="gotoMyProject" :pageSize="pbrIndexRightTablePageSize"
                         :data="myProjectData"></normal-list>
            <div v-else style="text-align: center;">
              <span @click="linkAddProject" style="cursor: pointer;color: #4a90e2;">{{$t('tabs.home.releaseProject')}}</span>
            </div>
          </TabPane>
          <a slot="extra" v-if="['newest','emphases'].includes(topTabName)" href="#"
             @click.prevent.stop = "topTabName === 'newest'? $router.push({ name: 'pbrProject'}) : $router.push({ path: '/pbr/project',query:{keyProject:'1'}})"
                 style="line-height: 31px;">{{ $t('buttons.more') }}</a>
        </Tabs>
      </div>
      <div class="pbr-index-right-item">
        <Tabs type="card" v-model="infoTabName" @on-click="infoTabClick">
          <TabPane name="sj" class="pbr-index-table pbr-index-tab-pane" :label="$t('tabs.home.projectOpportunity')">
            <normal-list v-if="infoTabName === 'sj'" :columns="['title','publishDate']" goto="pbrBusinessDetail"
                         :pageSize="pbrIndexRightTablePageSize" listKey="records" url="/front/business/list"></normal-list>
          </TabPane>
          <TabPane name="fx" class="pbr-index-tab-pane" :label="$t('tabs.home.projectRisk')">
            <normal-list v-if="infoTabName === 'fx'" :columns="['title','articleUpdateTime']" goto="pbrRiskDetail"
                         :pageSize="pbrIndexRightTablePageSize" listKey="records" url="/front/risk/list"></normal-list>
          </TabPane>
          <TabPane name="xm" class="pbr-index-tab-pane" :label="$t('tabs.home.projectInformation')">
            <normal-list v-if="infoTabName === 'xm'" :columns="['title','articleDate']" :pageSize="pbrIndexRightTablePageSize" :params="{pageNo:0, pageSize:20,from:'cn'}"
                         goto="pbrInfoDetail" listKey="content" method="POST"
                         url="/front/article/project/list"
            ></normal-list>
          </TabPane>
          <a slot="extra"
             @click.prevent.stop = "$router.push({ path: '/pbr/info',query: {tabPath: infoTabName}})"
             href="#"
             style="line-height: 31px;">{{ $t('buttons.more') }}</a>
        </Tabs>
      </div>
      <div class="pbr-index-right-item">
        <Tabs type="card" v-model="profileTabName">
          <TabPane name="pbrMyAttention" class="pbr-index-tab-pane" :label="$t('tabs.home.projectConcerns')">
            <normal-list ref="attention" v-if="profileTabName === 'pbrMyAttention'" :columns="['title','signDate']" :pageSize="pbrIndexRightTablePageSize"
                         :params="{pageNo:1, pageSize:20, from:'cn', hmodule:'mp'}" goto="pbrProjectDetail"
                         listKey="models" method="POST" url="/front/project/psearch" is-focused @open="openFocusModal"></normal-list>
          </TabPane>
          <TabPane name="collection" class="pbr-index-tab-pane" :label="$t('tabs.home.myCollections')">

            <el-tabs v-if="profileTabName === 'collection'" v-model="myFavorateActiveName"
                     class="my-collect">
              <el-tab-pane :label="$t('tabs.home.project')"
                           lazy
                           name="project">
                <normal-list :columns="['title']" :pageSize="pbrIndexRightTablePageSize - 1"
                             :params="{pageNo:1, pageSize:20, lang:'cn', type:3,userId:1}" goto="pbrProjectDetail"
                             listKey="records" url="/front/userFav/list"></normal-list>
              </el-tab-pane>
              <el-tab-pane :label="$t('tabs.home.opportunity')"
                           lazy
                           name="business">
                <normal-list :columns="['title']" :pageSize="pbrIndexRightTablePageSize - 1"
                             :params="{pageNo:1, pageSize:20, lang:'cn', type:1,userId:1}" goto="pbrBusinessDetail"
                             listKey="records" url="/front/userFav/list"></normal-list>
              </el-tab-pane>
              <el-tab-pane :label="$t('tabs.home.risk')"
                           lazy
                           name="risk">
                <normal-list :columns="['title']" :pageSize="pbrIndexRightTablePageSize - 1"
                             :params="{pageNo:1, pageSize:20, lang:'cn', type:4,userId:1}" goto="pbrRiskDetail"
                             listKey="records" url="/front/userFav/list"></normal-list>
              </el-tab-pane>
              <el-tab-pane :label="$t('tabs.home.enterprise')"
                           lazy
                           name="enterprise">
                <normal-list :columns="['title']" :pageSize="pbrIndexRightTablePageSize - 1"
                             :params="{pageNo:1, pageSize:20, lang:'cn', type:2,userId:1}" goto="pbrCompanyDetail"
                             listKey="records" url="/front/userFav/list"></normal-list>
              </el-tab-pane>
              <el-tab-pane :label="$t('tabs.home.information')"
                           lazy
                           name="info">
                <normal-list :columns="['title']" :pageSize="pbrIndexRightTablePageSize - 1"
                             :params="{pageNo:1, pageSize:20, lang:'cn', type:5,userId:1}" goto="pbrInfoDetail"
                             listKey="records" url="/front/userFav/list"></normal-list>
              </el-tab-pane>
            </el-tabs>
          </TabPane>
          <TabPane name="recommend" class="pbr-index-tab-pane" :label="$t('tabs.home.relevantRecommendations')">
            <normal-list v-if="profileTabName === 'recommend'" :columns="['title','pubDate']" :pageSize="pbrIndexRightTablePageSize"
                         :params="{pageNo:1, pageSize:20, from:'cn', hmodule:'rp'}" goto="pbrProjectDetail"
                         listKey="models" method="POST" url="/front/project/psearch"></normal-list>
          </TabPane>
          <a style="" slot="extra"
             v-if="['pbrMyAttention','collection'].includes(profileTabName)" href="#"
             @click.prevent.stop = "$router.push({ name: profileTabName,query:{t:5}})"
           >{{$t('buttons.more')}}</a>
<!--          <el-tooltip slot="extra"  v-model="questionVisible" :effect="isDark ? 'dark' : 'light'" :manual="true" content="" placement="bottom">-->
<!--            <p slot="content">我们将会以 <strong>****</strong> 代替您无权限查看的内容 </p>-->
<!--          <i class="el-icon-question pbr-question-icon" ref="questionIcon" @click="questionVisible = !questionVisible"></i>-->
<!--          </el-tooltip>-->
        </Tabs>
      </div>
    </el-col>

    <PublishProject ref="publish"></PublishProject>

    <pbr-focus-modal ref="focusModal" :succeed="refreshMyAttention"></pbr-focus-modal>
  </el-row>
</template>

<script>
import ProjectListCurly from './ProjectList_Curly.vue'
import NormalList from './NormalList.vue'
import Business from './charts/business/business.vue'
import Risk from './charts/risk/risk.vue'
import Project from './charts/project/project.vue'
import Mixin from './mixin'
import MyProject from '../project/PublishProject.vue'
import TdtMap from './map/TdtMap'
import PublishProject from '../project/PublishProject'
import {mapGetters, mapMutations} from 'vuex'
import PbrFocusModal from "../personal/FocusModal";
export default {
  name: 'pbrIndex',
  componentName: 'pbrIndex',
  mixins: [Mixin],
  inject: ['renderNotice','hideContainer'],
  components: {
    PbrFocusModal,
    TdtMap,
    ProjectListCurly,
    NormalList,
    Business,
    Risk,
    Project,
    MyProject,
    PublishProject
  },
  data () {
    return {
      questionVisible:false,
      myFavorateActiveName: 'project',
      emphasesCategory: '',
      isLoadMapDataError: false,
      maploadcount: 0,
      myProjectData: [],
      projectBusinessData: [],
      recommednProjectData: [],
      emphasisProjectData: [],
      leftData: null,
      pbrIndexRightTablePageSize: 5,
      spinShow: true,
      topTabName: 'newest',
      infoTabName: 'sj',
      profileTabName: 'pbrMyAttention'
    }
  },
  created () {
    this.fetchSeriousArticle()
  },
  computed: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    // spinShow () {
    //   let spinShow = this.$store.getters.pbrIndexModule.spinShow
    //   return spinShow !== undefined ? spinShow : true
    // },

    businessChartData () {
      if (this.leftData) {
        return JSON.parse(JSON.stringify(this.leftData, ['businessCountryChart', 'businessTypeChart', 'businessLineChart', 'projectNumChart', 'id', 'name', 'num', 'percentage', 'times', 'nums', 'totalNum']))
      }
      return {}
    },
    projectChartData () {
      if (this.leftData) {
        return JSON.parse(JSON.stringify(this.leftData, ['projectNationChart', 'projectIndustryChart', 'projectNumChart', 'id', 'name', 'num', 'percentage', 'times', 'nums', 'totalNum']))
      }
      return {}
    },
    riskChartData () {
      if (this.leftData) {
        return JSON.parse(JSON.stringify(this.leftData, ['riskTypeChart', 'riskNationChart', 'riskLineChart', 'projectNumChart', 'id', 'name', 'num', 'percentage', 'times', 'nums', 'totalNum']))
      }
      return {}
    }
  },
  methods: {
    linkAddProject(){
      this.$refs.publish.open()
    },
    loadMyProject(){
      this.$pbrAxios.post('/front/myproject/search',{}).then((res) => {
        if(res.code === 200){
          this.myProjectData = res.result.models
        }
      })
    },
    fetchSeriousArticle(){
      this.$pbrApis.fetchSeriousArticle({pageNo:0, pageSize:10,lang: 'cn', userId: 1}).then(res => {
        if(res && res.success){
          this.renderNotice(res.result.records)
        }
      })
    },
    topTabClick (name) {
      console.log(name)
    },
    infoTabClick (name) {
      console.log(name)
    },
    updateSpinShow (data) {
      this.spinShow = data
    },
    updateEmphasesCategory (data) {
      this.emphasesCategory = data
    },
    mapDataLoadFinished (data) {
      this.leftData = data
      this.spinShow = false
      this.windowResize()
      this.questionVisible = true
      // this.$store.commit('pbrIndexModule', { spinShow: false })
    },
    businessCountryChartClick (name) {
      let mapFilterTags = this.$refs.mapview.filterTags
      if (mapFilterTags.indexOf(name) < 0) {
        mapFilterTags.push(name)
      }
    },
    getChartReply (param) {
      this.emphasesCategory = param
    },
    loadInitData () {
    },
    filterData (params) {
      this.emphasesCategory = params.module
      this.broadcast('pbrMap', 'fetchDataByChart', params)
      this.broadcast('pbrTdtMap', 'fetchDataByChartData', params)
    },
    windowResize (e) {
      let pbrIndexRightTablePreHeight = (window.innerHeight - 160) /3 // document.querySelector('.pbr-index-right-col').clientHeight / 3
      // let tabbarHeight = parseFloat(window.getComputedStyle(document.querySelector('.ivu-tabs-bar')).height)
      // let pbrIndexRightTableLiHeight = document.querySelector('.pbr-index-table li') ? parseFloat(window.getComputedStyle(document.querySelector('.pbr-index-table li')).height) : 20
      // let pbrIndexRightTableLiMarginVertical = document.querySelector('.pbr-index-table li') ? parseFloat(window.getComputedStyle(document.querySelector('.pbr-index-table li')).marginTop) * 2 : 20
      // this.pbrIndexRightTablePageSize = Math.floor((pbrIndexRightTablePreHeight - tabbarHeight) / (pbrIndexRightTableLiHeight + pbrIndexRightTableLiMarginVertical))
      pbrIndexRightTablePreHeight = Math.floor(document.querySelector('.pbr-index-right-item').clientHeight)
      let tabbarHeight = parseFloat(window.getComputedStyle(document.querySelector('.ivu-tabs-bar')).height)
      let tabbarMarginBottom = parseFloat(window.getComputedStyle(document.querySelector('.ivu-tabs-bar')).marginBottom)
      let pbrIndexRightTableLiHeight = document.querySelector('.pbr-index-table li') ? parseFloat(window.getComputedStyle(document.querySelector('.pbr-index-table li')).height) : 10
      let pbrIndexRightTableLiMarginVertical = document.querySelector('.pbr-index-table li') ? parseFloat(window.getComputedStyle(document.querySelector('.pbr-index-table li')).marginTop) * 2 : 10
// document.querySelector("#bbbb").innerHTML=`(${pbrIndexRightTablePreHeight}-${tabbarHeight}-${tabbarMarginBottom}) / (${pbrIndexRightTableLiHeight}+${pbrIndexRightTableLiMarginVertical})`
      this.pbrIndexRightTablePageSize = Math.floor((pbrIndexRightTablePreHeight - tabbarHeight - tabbarMarginBottom)  / (pbrIndexRightTableLiHeight + pbrIndexRightTableLiMarginVertical))
      console.log('pbrIndexRightTablePageSize', this.pbrIndexRightTablePageSize)
    },
    loadMapDataError (flag) {
      this.isLoadMapDataError = flag
    },
    spinRefreshClick () {
      this.isLoadMapDataError = false
      this.maploadcount += 1
    },
    gotoMyProject (detail) {
      this.$refs.publish.open(detail)
    },
    openFocusModal () {
      this.$refs.focusModal.open()
    },
    refreshMyAttention () {
      this.$refs.attention.loadData()
    },
    showWarning(){
      let isFirstLaunch = this.$store.getters.pbrIsFirstLaunch
      let self = this
      if (isFirstLaunch){
        this.isFirstLaunch(false)
        this.$notify({
          title: self.$t('message.asterisk.title'),
          dangerouslyUseHTMLString: true,
          type: 'info',
          duration: 5000,
          message: self.$t('message.asterisk.message'),
          position: 'bottom-right'
        });
      }
    },
    ...mapMutations(['isFirstLaunch'])
  },
  mounted () {
    let self = this
    this.loadMyProject()
    this.$nextTick(() => {
      // let pbrIndexRightTablePreHeight = document.querySelector('.pbr-index-right-col').getBoundingClientRect().height / 3
      // let tabbarHeight = parseFloat(window.getComputedStyle(document.querySelector('.ivu-tabs-bar')).height)
      // let pbrIndexRightTableLiHeight = document.querySelector('.pbr-index-table li') ? parseFloat(window.getComputedStyle(document.querySelector('.pbr-index-table li')).height) : 20
      // let pbrIndexRightTableLiMarginVertical = parseFloat(window.getComputedStyle(document.querySelector('.pbr-index-table li')).marginTop) * 2
      // self.pbrIndexRightTablePageSize = Math.floor((pbrIndexRightTablePreHeight - tabbarHeight) / (pbrIndexRightTableLiHeight + pbrIndexRightTableLiMarginVertical))

      // console.log('pbrIndexRightTablePageSize', self.pbrIndexRightTablePageSize)
      // this.windowResize()
      this.showWarning()

    })
    this.$on('filterData', this.filterData)
  },
  activated () {
    window.addEventListener('resize', this.windowResize)
  },
  deactivated () {
    window.removeEventListener('resize', this.windowResize)
  },

  watch: {},
  provide () {
    /**
     * p rovide/inject 绑定并不是响应式的。我们可以通过传递一个 ref property 或 reactive 对象给 provide 来改变这种行为。
     * provide() {
          return {
            todoLength: Vue.computed(() => this.todos.length)
          }
        }
     */
    return {
      chartDatas: {
        projectChartData: () => this.projectChartData,
        businessChartData: () => this.businessChartData,
        riskChartData: () => this.riskChartData
      },
      loadMapDataError: this.loadMapDataError,
      updateSpinShow: this.updateSpinShow,
      updateEmphasesCategory: this.updateEmphasesCategory,
      mapDataLoadFinished: this.mapDataLoadFinished,
      windowResize:this.windowResize
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.windowResize)
  }
}
</script>

<style scoped>
.echarts-box {
  float: left;
  width: 33.3333%;
  height: 100%;
  padding-top: 10px;
}

.my-collect >>> .el-tabs__header {
  margin: 0 !important;
}

.my-collect >>> .el-tabs__nav-scroll {
  display: flex;
  /*padding-left: 20px;*/
  /*justify-content: center;*/
}

.my-collect >>> .el-tabs__item {
  font-size: 12px;
  font-weight: 400;
  height: 30px;
  line-height: 30px;
  padding: 0 12px;
}

.my-collect >>> span.el-tabs__nav-prev,
.my-collect >>> span.el-tabs__nav-next {
  line-height: 30px;
}

.my-collect >>> .el-tabs__active-bar {
  background-color: initial;
}

.my-collect >>> .el-tabs__nav-wrap::after {
  background-color: initial;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
  margin: 10px 0;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/**
* 解决iView tab-pane 页面模糊
*/
.pbr-index-tab-pane {
  backface-visibility: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
}

</style>
<style>
.pbrSpin .ivu-spin-text {
  display: flex;
}
</style>
